/**
 * @class
 * @classdesc Model for WhitelistUser on DB
 * * */
export default class Owner {
  /**
   *Constructor - sets a model for whitelist user Data according to DB
   * @param {String} id
   * @param {Number} whitelistId
   * @param {Number} clientId
   * @param {String} phoneNumber
   * @param {String} email
   * @param {Boolean} name
   * @param {Boolean} validFrom
   * @param {String} validTo
   * @param {Boolean} chargeForSessions
   * @param {String} registrationType
   * @param {String} registeredAt
   * @param {String} status
   * @param {String} comments
   * @param {Boolean} startSessionsWithLPR
   * @param {Array} vehicles
   */

  #WhitelistUserObject = {}

  constructor(
    id,
    whitelistId,
    clientId,
    phoneNumber,
    email,
    name,
    validFrom,
    validTo,
    chargeForSessions,
    comments,
    startSessionsWithLPR,
    vehicles,
    registrationType
  ) {
    this.#WhitelistUserObject.Id = id || null
    this.#WhitelistUserObject.WhitelistId = whitelistId || null
    this.#WhitelistUserObject.ClientId = clientId || null
    this.#WhitelistUserObject.PhoneNumber = phoneNumber || ''
    this.#WhitelistUserObject.Email = email || ''
    this.#WhitelistUserObject.Name = name || ''
    this.#WhitelistUserObject.ValidFrom = validFrom || this.getValidFrom()
    this.#WhitelistUserObject.ValidTo = validTo || this.getValidTo()
    this.#WhitelistUserObject.ChargeForSessions = chargeForSessions || false
    this.#WhitelistUserObject.Comments = comments || ''
    this.#WhitelistUserObject.StartSessionsWithLPR = startSessionsWithLPR
    this.#WhitelistUserObject.Vehicles = vehicles || []
    this.#WhitelistUserObject.RegistrationType =
      registrationType || 'MANUALLY_ADDED'
  }

  getValidFrom() {
    if (!this.validFrom) {
      return null
    }
    return this.validFrom
  }

  getValidTo() {
    if (!this.validTo) {
      return null
    }
    return this.validTo
  }

  /**
   * Get Whitelist Object
   * @return {Object} Whitelist Javascript object
   */
  getObject() {
    return this.#WhitelistUserObject
  }
}
